import React, { useState, useCallback } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const googleApiKey = 'AIzaSyC75q_cO4SIMGhQgRJwAIpNfNQ5cXwVXnU';

export const GMapsMultipleMarkerComponent = ({ center, lenguage, markers, customHeight }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleApiKey,
  });

  const [map, setMap] = useState(null);
  const [showFullScreen, setShowFullScreen] = useState(false);

  const onLoad = useCallback((map) => setMap(map), []);
  const onUnmount = useCallback(() => setMap(null), []);

  const centerOfMap = {
    lat: parseFloat(center?.space_latitude?.trim()),
    lng: parseFloat(center?.space_logitude?.trim()),
  };

  const mapStyles = [
    {
      featureType: 'all',
      elementType: 'geometry',
      stylers: [{ saturation: -30 }],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#f5f3e5' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#e0e0e0' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#d9e3f0' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#e5e9d3' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [{ color: '#6c75f0' }],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6c75f0' }],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#808080' }],
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#808080' }],
    },
  ];

  const containerStyle = {
    width: '100%',
    height: customHeight ?? '200px',
    borderRadius: '8px',
  };

  const fullScreenStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 9999,
  };

  const isReadyToMap = isLoaded && markers;

  return isReadyToMap ? (
    <>
      <FlexContainer
        className="flex-column margtb20 border-rad8px grayShadowBottom"
        onClick={() => setShowFullScreen(true)}
        style={{ cursor: 'pointer' }}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={centerOfMap}
          zoom={11}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            styles: mapStyles,
            disableDefaultUI: true,
            draggable: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            keyboardShortcuts: false,
            gestureHandling: 'none',
          }}
        >
          {window.google &&
            markers
              .map((space) => ({
                lat: parseFloat(space.space_latitude.trim()),
                lng: parseFloat(space.space_logitude.trim()),
                spaceData: space,
              }))
              .filter((space) => !isNaN(space.lat) && !isNaN(space.lng))
              .map((space, index) => {
                const price = space?.spaceData?.formattedPrice || '$0';
                const svg = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="70" height="55">
                    <path d="
                      M10,20 
                      Q10,5 25,5 
                      H45 
                      Q60,5 60,20 
                      V30 
                      Q60,45 35,45 
                      L30,55 
                      L25,45 
                      Q10,45 10,30 
                      Z" fill="#2C3E50"/>
                    <text x="35" y="30" text-anchor="middle" font-family="Arial" font-size="12" fill="white" font-weight="bold">
                      ${price}
                    </text>
                  </svg>
                  `;

                const encoded = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
                return (
                  <Marker
                    key={index}
                    position={{ lat: space.lat, lng: space.lng }}
                    icon={{
                      url: encoded,
                      scaledSize: new window.google.maps.Size(60, 50),
                      anchor: new window.google.maps.Point(30, 50),
                    }}
                  />
                );
              })}
        </GoogleMap>
      </FlexContainer>

      {showFullScreen && (
        <div style={fullScreenStyle} onClick={() => setShowFullScreen(false)}>
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={center}
            zoom={16}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              styles: mapStyles,
              disableDefaultUI: false,
              gestureHandling: 'auto',
            }}
          >
            <Marker position={center} />
          </GoogleMap>
        </div>
      )}
    </>
  ) : null;
};
